import React, { useState } from "react";
import client from "@/lib/api";
import { toast } from "sonner";
import { errMsg } from "./adminShared";

export default function AdminLogin({ onLogin }) {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const { data } = await client.post("/admin/login", { email, password });
            localStorage.setItem("uk_admin_token", data.token);
            onLogin();
        } catch (err) {
            toast.error(errMsg(err, "Login failed"));
        } finally {
            setLoading(false);
        }
    };

    const input = "w-full mt-3 bg-brand-ink border border-brand-line px-4 py-3 rounded-sm focus:outline-none focus:border-brand-olive";
    return (
        <div className="min-h-screen flex items-center justify-center px-6 bg-brand-ink">
            <form onSubmit={submit} className="w-full max-w-md border border-brand-line p-10 rounded-sm bg-brand-charcoal admin-fade">
                <p className="font-script text-brand-gold text-3xl">Umami Kraft</p>
                <h1 className="font-display text-3xl mt-1">Admin sign in</h1>
                <p className="text-sm text-brand-mute mt-2">Manage menu, specials, orders and site content.</p>
                <input data-testid="admin-email" required type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className={`${input} mt-6`} />
                <input data-testid="admin-password" required type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className={input} />
                <button data-testid="admin-login-btn" disabled={loading} className="btn-primary w-full mt-6">{loading ? "Signing in…" : "Sign in"}</button>
                <a href="/" className="block text-center text-xs text-brand-mute mt-5 hover:text-brand-gold">← Back to site</a>
            </form>
        </div>
    );
}
